export default __webpack_public_path__ + "static/media/09_Major_cave.75995380.webp";